import 'element-ui/lib/theme-chalk/index.css';
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import VueResource from 'vue-resource';
import auth from './auth/index';
//import i18n from 'vue-i18n';
import VueWebsocket from "vue-websocket";
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination.vue';
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo.vue';
import VuetablePaginationDropdown  from 'vuetable-2/src/components/VuetablePaginationDropdown.vue';


import RelayTable from './components/admin/Devices/RelayTable.vue';
import VueHighcharts from 'vue-highcharts';
import history from 'vue-history-api-fallback';

import Highcharts from "highcharts";
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';
import loadStock from 'highcharts/modules/stock';

import locale from 'element-ui/lib/locale/lang/en'

loadStock(Highcharts)
highchartsMore(Highcharts);
solidGauge(Highcharts);

Vue.component('relay-table', RelayTable)
Vue.component('vuetable', Vuetable);
Vue.component("vuetable-pagination", VuetablePagination);
Vue.component("vuetable-pagination-info", VuetablePaginationInfo);

Vue.config.productionTip = false

Vue.use(ElementUI, { locale })
Vue.use(VueResource);
Vue.use(VueWebsocket);
Vue.use(VueHighcharts);

auth.checkAuth()
// import 'element-ui/lib/theme-default/index.css';

// Allows us to use font-awesome icons, see .less for more
import './style.less'

Vue.config.silent = true;

router.beforeEach((to, from, next) => {
  if(to.path === '/' || to.path === '/booking') {
    next();
  } else if ( to.path === '/forgot-password' || to.path === '/resetPassword') {
    if(auth.user.authenticated) {
      next('/sites');
    } else {
      next();
    }
  } else if (to.path === '/change_password') {
      next()
  } else if(to.path.includes("admin")){
    if(auth.user.role < 2){
      next("/unauthorized");
    } else {
      if(to.path === "/admin/devices"){
        if(auth.user.role == 3){
          next();
        } else {
          next("/unauthorized")
        }
      } else {
        next();
      }
      
    }
  } else if(to.path === "/scheduler"){
    if(auth.user.role < 0){
      next("/unauthorized")
    } else {
      next();
    }
  } else if(to.path !== "/login"){
    if(!auth.user.authenticated){
      next("/login");
    } else {
      next();
    }
  } else { // Navigating to login
    if(auth.user.authenticated){
      next("/sites"); //If logged in, navigate to sites
    } else {
      next();
    }
  }
});

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js